import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const AgentsAwarenessModalLoadable: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentsAwarenessModalConnected" */
				'../src/AgentsAwarenessModalConnected.tsx'
			)
		).AgentsAwarenessModalConnected,
});
